import React, {FC, ReactElement} from "react";
import {Box, Grid} from "@mui/material";
import {useTranslation} from "react-i18next";
import {getCurrentLanguage} from "../utils/Helpers";

export const Footer: FC = (): ReactElement => {
    const {i18n} = useTranslation()
    let key = getCurrentLanguage(i18n);


    return (
        <div style={{display:"flex", alignItems:"center", marginTop: 32}}>
            <div style={{marginRight:"auto"}}>
                <Box
                    component="img"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    alt="Footer"
                    sx={{
                        marginLeft: 8,
                        height: { xl: "105%"},
                        width: { xl: "105%"},
                        maxHeight: {xl: "105%"},
                        maxWidth: {xl: "105%"},
                    }}
                    src={require("../assets/logos/tum-logo.png") }
                />
            </div>
            <div>
                 <Grid container justifyContent="flex-end">
                     <Box
                        component="img"
                        display="flex"
                        sx={{
                            marginRight: 8,
                            height: {xs: "75%", md: "35%", xl: "25%"},
                            width: {xs: "75%", md: "35%", xl: "25%"},
                            maxHeight: {xs: "75%", md: "35%",xl: "25%"},
                            maxWidth: {xs: "75%", md: "35%",xl: "25%"},
                        }}
                        alt="Footer"
                        src={key === "en" ? require("../assets/logos/footer_en.jpg") : require("../assets/logos/footer_de.png")}
                    />
                 </Grid>
            </div>
        </div>
    );
};

export default Footer;
